import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

import { ActionPlanListPageComponent } from '../pages/list.component';
import { ActionPlanDetailPageComponent } from '../pages/detail.component';
import { ResponsibleDetailPageComponent } from '../pages/responsible-detail.component';
import { ActionPlanItemDetailPageComponent } from '../pages/item-detail.component';
import { ActionPlanReportPdfListPageComponent } from '../pages/report-pdf-list.component';
import { ActionPlanItemStatusEditPageComponent } from '../pages/item-status-edit.component';
import { ActionPlanCollaboratePageComponent } from '../pages/collaborate.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver },
    children: [
      { path: `${appRoute}/actionPlans`, component: ActionPlanListPageComponent },
      { path: `${appRoute}/actionPlans/:actionPlanId`, component: ActionPlanDetailPageComponent },
      {
        path: `${appRoute}/actionPlans/:actionPlanId/responsible/:responsibleIndex`,
        component: ResponsibleDetailPageComponent
      },
      {
        path: `${appRoute}/actionPlans/:actionPlanId/actionPlanItem/:actionPlanItemId/editstatus`,
        component: ActionPlanItemStatusEditPageComponent
      },
      {
        path: `${appRoute}/actionPlans/:actionPlanId/actionPlanItem/:actionPlanItemId`,
        component: ActionPlanItemDetailPageComponent
      },
      { path: `${appRoute}/actionPlans/:itemId/reports`, component: ActionPlanReportPdfListPageComponent }
      // { path: `${appRoute}/actionPlans/:actionPlanId/collaborate`, component: ActionPlanCollaboratePageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActionPlanRoutingModule {}

export const routedComponents = [
  ActionPlanListPageComponent,
  ActionPlanDetailPageComponent,
  ResponsibleDetailPageComponent,
  ActionPlanDetailPageComponent,
  ActionPlanItemStatusEditPageComponent,
  ActionPlanCollaboratePageComponent
];
